import { SelectData } from './select-input.model';

export interface CertifierQueueFilter {
  certificadora: SelectData;
  nomeFundo: SelectData;
  dataProcessamento: Date;
  status: SelectData;
}

export interface CertifierQueueRequest {
  idFundo: number;
  idCertificadora: number;
  dataProcessamento: Date;
  status: string;
}

export interface CertifierQueueTable {
  nomeFundo: string;
  nomeCertificadora: string;
  nomeArquivo: string;
  dataProcessamento: Date;
  inicioEvento: Date;
  status: string;
  mensagem: string;
}
